import React from 'react'
import ReactHtmlParser from 'react-html-parser'

const renderHTML = rawHTML =>
	React.createElement('div', {
		dangerouslySetInnerHTML: { __html: ReactHtmlParser(rawHTML) }
	})

export default renderHTML
